export class BillingRedirectError implements Error {
  name: string;
  message: string;
  stack?: string;
}
